import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容频道',
    links: [
      { label: '新闻资讯', to: '/news' },
      { label: '影视娱乐', to: '/entertainment' },
      { label: '生活服务', to: '/lifestyle' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '平台简介', to: '/about' },
      { label: '服务说明', to: '/about' },
      { label: '联系方式', to: '/about' },
    ],
  },
  {
    title: '热门标签',
    links: [
      { label: '社会民生', to: '/news' },
      { label: '科技创新', to: '/news' },
      { label: '影视推荐', to: '/entertainment' },
      { label: '健康生活', to: '/lifestyle' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg font-bold text-background-50 dark:text-foreground-950">
                小
              </span>
              <span className="font-heading text-lg font-bold text-background-50">小 · 多元内容聚合平台</span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-background-300">
              聚合新闻资讯、影视娱乐与生活服务，为普通网民提供一站式便捷的信息获取平台。
            </p>
            <div className="mt-5 flex gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-background-200">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-background-200">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-800 text-background-200">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link, index) => (
                  <li key={`${col.title}-${index}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 小 · 多元内容聚合平台. 本站为前端演示站点，内容仅用于展示。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>隐私说明</span>
            <span>使用条款</span>
            <span>友情链接</span>
          </p>
        </div>
      </div>
    </footer>
  );
}